<template>
  <button
    :class="[ { 'border-neutral-200 bg-white' : !props.active && !props.filterSet }, { 'border-petrol-500 bg-white' : props.active && !props.filterSet }, { 'border-petrol-500 bg-petrol-50' : props.filterSet }, 'rounded-full border inline-block cursor-pointer leading-5 text-sm max-w-full min-w-0 overflow-hidden' ]"
  >
    <span class="flex items-center min-w-0 max-w-full">
      <span class="pl-3 pr-1.5 -mt-1 shrink-0">
        <UiIcon
          src="/svg/icons/filter.svg"
          width="17"
          height="11"
          :class="[{'stroke-neutral-800 inline-block' : !props.active }, {'stroke-petrol-500 inline-block' : props.active }]"
        />
      </span>
      <span class="py-3 pr-4 truncate min-w-0">
        <slot />
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  active: {
    type: Boolean,
    default: false
  },
  filterSet: {
    type: Boolean,
    default: false
  }
})
</script>
